import React from "react";
import { useNavigate, useParams } from "react-router";
import useModulePermission from "../../customHooks/ModulePermission/useModulePermission";
import { IoArrowBackCircle } from "react-icons/io5";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import "./ModulePermission.css";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";

const ModulePermission = () => {
  const params = useParams();
  const { id } = params;
  const { moduleData, loader } = useModulePermission({ id });
  const navigate = useNavigate();
  const canRead = usePermission("MODULE_READ");
  return (
    <div className="container">
      {canRead ? (
        <>
          <div className="flex justify-end">
            <button onClick={() => navigate("/module")} className="back">
              <IoArrowBackCircle size={20} /> Back
            </button>
          </div>
          {!loader ? (
            <>
              {" "}
              {moduleData && (
                <div className="roleContainer">
                  <div className="role-details">
                    <h1 className="text-xl text-center">Module Details</h1>

                    <div className="detail-item">
                      <label>Module Name:</label>
                      <p>{moduleData?.name || "N/A"}</p>
                    </div>

                    <div className="detail-item">
                      <label>Module Description:</label>
                      <p>{moduleData?.description || "N/A"}</p>
                    </div>
                    <div className="detail-item">
                      <label>Application Mapped:</label>
                      <p>{moduleData?.applicationName || "N/A"}</p>
                    </div>
                  </div>

                  <div className="permissions-tree">
                    <h1 className="text-xl text-center">Module Permissions</h1>
                    <ol className="wtree text-black">
                      {moduleData.modulePermissions.map((app) => {
                        return (
                          <li key={app.permissionId} className="">
                            {" "}
                            <label className="permission-item">
                              {app.permissionName}
                            </label>
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <FullPageLoading />
            </>
          )}
        </>
      ) : (
        <UnAuthorized />
      )}
    </div>
  );
};

export default ModulePermission;
